export enum UploadFileHeaderEnum {
  WINE = "wine",
  WINERY = "winery",
  REGION = "region",
  TYPE = "type",
  VINTAGE = "vintage",
  SIZE = "size",
  PRICE = "price",
  QUANTITY = "quantity",
  PACKAGING = "packaging",
  B2B_MARKET_PRICE = "b2b_market_price",
  B2B_MARKET_PRICE_CURRENCY = "b2b_market_price_currency",
  VINTAGE_PRODUCT_UUID = "vintage_product_uuid",
  VINTAGE_UUID = "vintage_uuid",
  SCORE_AUTHOR = "score_author",
  SCORE_VALUE = "score_value",
  SCORE_YEAR = "score_year",
}
